























































































import { Component, Vue } from "vue-property-decorator";
import { LibriSearchRequest } from "@/data/models/biblioteca.model";

@Component({})
export default class BibliotecaSearch extends Vue {
  searchparam: LibriSearchRequest = new LibriSearchRequest();
  anno: number | null = null;

  search() {
    this.searchparam.anno =
      this.anno === null || Number.isNaN(this.anno) ? undefined : this.anno;
    this.$emit("search", { ...this.searchparam });
  }

  reset() {
    this.searchparam = new LibriSearchRequest();
    this.anno = null;
    this.search();
  }
}
